import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { onError } from "apollo-link-error";
import { createUploadLink } from 'apollo-upload-client';
import { errorTranslator } from './methods';
import toast from './toast';

let token = null;

export const setClientToken = (value) => {
    token = value;
}

export const getClientToken = () => {
    return token;
}

let language = null;

export const setClientLanguage = (value) => {
    language = value;
}

export const getClientLanguage = () => {
    return language;
}

const errorLink = onError(({ graphQLErrors, networkError, response }) => {
    if (graphQLErrors) {
        graphQLErrors.forEach(({ message, locations, path }) =>
            toast.error(errorTranslator(graphQLErrors[0].message))
        );
    }

    if (networkError) {
        toast.error(errorTranslator('error.network_error'));
    };
});

const authLink = setContext((operation, { headers }) => {
    const token = getClientToken();

    if (!headers) {
        headers = {};
    }

    if (token) {
        headers.Authorization = token;
    }

    if (language) {
        headers.Language = language;
    }

    return {
        headers: {
            ...headers
        }
    }
});

const client = new ApolloClient({
    link: ApolloLink.from([
        errorLink,
        authLink,
        createUploadLink({
            uri: process.env.REACT_APP_BACKEND_HOST,
        }),
    ]),
    cache: new InMemoryCache(),
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'network-only',
            errorPolicy: 'ignore',
        },
        query: {
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
        },
    }
});

export default client;